// Refer to Lucide documentation for more details https://lucide.dev/guide/packages/lucide-react
import type { DynamicIconNameType } from '@cloud/shared/ui'
import type { LucideProps } from 'lucide-react'
import { icons } from 'lucide-react'

interface DynamicIconProps extends LucideProps {
  name: DynamicIconNameType
}

// Component to render a dynamic Lucide icon based on its name.
export function DynamicIcon({ name, ...props }: DynamicIconProps) {
  // Alleen een EIGEN sleutel: `icons['constructor']` of `icons['toString']` geven via het
  // prototype een functie terug die React als component probeert te tekenen — en dan crasht
  // (de icoonpreview in de taakeditor krijgt vrije invoer, audit 2026-09-29).
  const LucideIcon = Object.hasOwn(icons, name) ? icons[name] : undefined

  // Return null if the icon name is invalid.
  if (!LucideIcon) return null

  return <LucideIcon {...props} />
}
